module.exports = "<h1>{{headings}}</h1>\r\n<div data-ui-view='hero'></div\r\n><div data-ui-view='eSpots'></div\r\n>";